exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-fff4a968] {\n  pointer-events: none;\n  position: fixed;\n  right: 0;\n}\nsvg polygon[data-v-fff4a968],\nsvg rect[data-v-fff4a968] {\n  pointer-events: auto;\n}\n", ""]);

